export interface PaymentMatch {
  id: string;
  invoiceId: string;
  zohoTransactionId: string;
  bankAccountName: string;
  transactionDate: string;
  transactionAmountEur: number;
  amountDifferenceEur: number;
  transactionReference: string;
  invoiceCustomerName: string;
  aiConfidence: number;
  status: PaymentMatchStatus;
  reviewedByUserId: number;
  createdAt: string;
  reviewedAt: string;
  invoiceZohoNumber: string;
  invoiceUserEmail: string;
  zohoTransactionUrl: string;
}

export type PaymentMatchStatus = 'PENDING_REVIEW' | 'APPROVED' | 'REJECTED' | 'APPLIED' | 'FAILED';

export interface PaymentMatchPage {
  content: PaymentMatch[];
  totalElements: number;
  totalPages: number;
}

export interface PaymentCategorization {
  id: string;
  zohoTransactionId: string;
  bankAccountName: string;
  transactionDate: string;
  transactionAmountEur: number;
  transactionReference: string;
  proposedUserId: number;
  proposedCustomerName: string;
  aiConfidence: number;
  aiReason: string;
  status: PaymentCategorizationStatus;
  reviewedByUserId: number;
  createdAt: string;
  reviewedAt: string;
  zohoTransactionUrl: string;
  allocations: PaymentCategorizationAllocation[];
}

export interface PaymentCategorizationAllocation {
  id: string;
  invoiceId: string;
  allocationOrder: number;
  amountAppliedEur: number;
  invoiceAmountDueEur: number;
  fullPayment: boolean;
  invoiceZohoNumber: string;
  invoiceCustomerName: string;
}

export type PaymentCategorizationStatus = 'PENDING_REVIEW' | 'APPLIED' | 'REJECTED' | 'FAILED';

export interface PaymentCategorizationPage {
  content: PaymentCategorization[];
  totalElements: number;
  totalPages: number;
}

export interface ZohoBankAccount {
  id: string;
  accountName: string;
  enabled: boolean;
  allowNearAmountMatching: boolean;
  allowCategorization: boolean;
  lastCheckedAt: string;
}

export interface MatchingJobStatus {
  running: boolean;
  lastFinishedAt: string | null;
  error: string | null;
}

export interface PaymentMatchingSettings {
  autoMatchingEnabled: boolean;
}

export function paymentApprovalError(
  error: { error?: string | { message?: string; error?: string }; statusText?: string },
  fallback: string
): string {
  const body = error?.error;
  return (typeof body === 'string' ? body : body?.message || body?.error) || error?.statusText || fallback;
}
